// src/components/WebsiteComponents/ImageUploader.js
export function ImageUploader({ imageUrl, onUpload }) {
  return (
    <div>
      <input 
        type="file" 
        onChange={(e) => {
          // Ici vous implémenteriez la logique d'upload
          // Pour l'instant, un simple placeholder
          if (e.target.files.length) {
            onUpload(URL.createObjectURL(e.target.files[0]));
          }
        }}
      />
      {imageUrl && <img src={imageUrl} alt="Preview" style={{ maxWidth: '100%' }} />}
    </div>
  );
}